import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';

import TableRender, { TableRenderFieldT } from 'shared/components/Table/TableRender';
import { IPNetworkT } from 'shared/models/ip-networks';
import api from 'utils/api';
import { datePrettyDisplay, formatDateFromNow } from 'utils/date';

import './IPNetworks.scss';

function IPNetworks() {
  const history = useHistory();

  const fields: TableRenderFieldT[] = [
    {
      displayName: 'Name',
      renderFn: (row: IPNetworkT) => row.name,
    },
    {
      displayName: 'Prefix',
      renderFn: (row: IPNetworkT) => row.prefix,
      align: 'center',
    },
    {
      displayName: 'Free',
      renderFn: (row: IPNetworkT) => row.free,
      align: 'center',
    },
    {
      displayName: 'Reserved',
      renderFn: (row: IPNetworkT) => row.reserved,
      align: 'center',
    },
    {
      displayName: 'Last Update',
      renderFn: (row: IPNetworkT) => formatDateFromNow(row.lastUpdated),
      tooltipFn: (row: IPNetworkT) => datePrettyDisplay(row.lastUpdated),
      align: 'center',
    },
  ];

  const goToID = (id: string) => {
    history.push(`/ip-networks/${id}`);
  };

  return (
    <div>
      <div className="title__header">
        <h1>IP Networks</h1>
        <Link to="/ip-networks/create">
          <Button variant="contained" color="secondary">Create</Button>
        </Link>
      </div>
      <TableRender
        api={api.IPNetwork}
        renderFields={fields}
        onClickRow={(row: IPNetworkT) => goToID(row.id)}
      />
    </div>
  );
}

export default IPNetworks;
